import { useRef, useState, type ChangeEvent, type DragEvent } from 'react';

interface FileDropProps {
  label: string;
  hint?: string;
  accept?: string;
  fileName?: string;
  onSelect: (fileName: string) => void;
  required?: boolean;
}

export default function FileDrop({
  label,
  hint = 'PNG أو JPG — بحد أقصى 5 ميجابايت',
  accept = 'image/*,.pdf',
  fileName,
  onSelect,
  required = false,
}: FileDropProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  const handleFiles = (files: FileList | null) => {
    if (files && files.length > 0) onSelect(files[0].name);
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    handleFiles(event.target.files);
  };

  const onDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setDragging(false);
    handleFiles(event.dataTransfer.files);
  };

  return (
    <div className="w-full">
      <p className="mb-2 font-medium text-[13px] text-foreground-800">
        {label} {required && <span className="text-danger-500">*</span>}
      </p>
      <div
        onDragOver={(event) => {
          event.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={onDrop}
        onClick={() => inputRef.current?.click()}
        className={[
          'flex cursor-pointer flex-col items-center justify-center gap-2 rounded-card border border-dashed px-4 py-6 text-center transition-colors',
          dragging
            ? 'border-secondary-400 bg-secondary-50'
            : 'border-background-300 bg-background-50 hover:border-secondary-300 hover:bg-background-100',
        ].join(' ')}
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
          <i
            className={fileName ? 'ri-check-line text-xl' : 'ri-upload-cloud-2-line text-xl'}
            aria-hidden="true"
          ></i>
        </span>
        {fileName ? (
          <span className="text-[13px] font-medium text-success-600">{fileName}</span>
        ) : (
          <>
            <span className="text-[13px] font-medium text-foreground-800">
              اسحب الملف هنا أو اضغط للاختيار
            </span>
            <span className="text-[12px] text-foreground-400">{hint}</span>
          </>
        )}
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          className="hidden"
          onChange={onChange}
        />
      </div>
    </div>
  );
}